// import { Loading } from 'element-ui';
import { checkUrl } from '@/utils/utils'
import axios from 'axios';
import { Message } from 'element-ui'
import router from './router.js';

window.$glob = {
  url: '',
  params: {},
  query: {},
  header: {}
};
function getGlobParams () {
  var query = window.location.search.substring(1);
  query = query.split("&");
  query.forEach(ele => {
    var pair = ele.split("=");
    window.$glob.params[pair[0]] = pair[1]
  })
}
getGlobParams();
axios.defaults.timeout = 30000;
//返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500; // 默认的
};
//跨域请求，允许保存cookie
// let loadingInstance = '';
// axios.defaults.withCredentials = true;
axios.interceptors.request.use(config => {
  // loadingInstance = Loading.service({
  //   text: '拼命加载中',
  //   background: 'rgba(0,0,0,0)',
  //   spinner: 'el-icon-loading'
  // });
  const token = localStorage.getItem("daping_token");
  // const token = sessionStorage.getItem("daping_token");
  if(token){
    config.headers['token'] = token// token
  }
  if (!checkUrl(config.url)) config.url = window.$glob.url + config.url;
  let header = window.$glob.header || {};
  config.headers = Object.assign(config.headers, header);
  let data = window.$glob.query || {}
  let key;
  if (['get', 'delete'].includes(config.method)) {
    key = "params"
  } else if (['post', 'put'].includes(config.method)) {
    key = "data"
  }
  if (typeof (config[key]) === 'object') {
    config[key] = Object.assign(config[key] || {}, data)
  }
  if (config.headers.proxy) {
    let headers = {}
    for (let ele in config.headers) {
      if (typeof (config.headers[ele]) !== 'object') headers[ele] = config.headers[ele]
    }
    let form = {
      url: config.url,
      method: config.method,
      headers: headers
    }
    form[key] = config[key]
    config.url = window.$website.url + '/visual/proxy'
    config.method = 'post';
    config.data = form
  }
  return config
}, error => {
  return Promise.reject(error)
});
// HTTPresponse拦截
axios.interceptors.response.use(res => {
  const status = Number(res.data.res) || 0
  const message = res.data.msg 

  // 后台定义 424 针对令牌过去的特殊响应码
  if (status === -1) {
    router.push("/login")
    return
  }

  // 二进制数据则直接返回
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    if (!res.headers['content-disposition']) {
      return false
    }
    const link = document.createElement('a') //创建一个a标签
    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' }) //实例化一个blob出来
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob) //将后端返回的数据通过blob转换为一个地址
    link.download = decodeURI(res.headers['content-disposition'].split('=')[1])
    //设置下载下来后文件的名字以及文件格式
    document.body.appendChild(link)
    link.click() //下载该文件
    return
  }

  if (status !== 0 || res.data.code === 1) {
    Message({
      showClose: true,
      message: message,
      type: 'warning'
    });
  }

  return res
}, error => {
  // 处理 503 网络异常
  if (error.response.status === 503) {
    Message({
      message: error.response.data.msg,
      type: 'error'
    })
  }
  return Promise.reject(new Error(error))
})

export default axios;
